import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'renderImage'
})
export class RenderImagePipe implements PipeTransform {
  private baseUrl = 'YOUR_BASE_URL_HERE'; // Replace with actual base URL

  transform(image: any): string {
    if (image) {
      const [baseUrl, imgUrl] = image.split('uploads');
      return `${this.baseUrl}uploads${imgUrl}`;
    } else {
      return 'assets/images/church.jpeg';
    }
  }
}
